module.exports = __webpack_public_path__ + "img/empty.1ada0508.svg";